import { render, staticRenderFns } from "./ProductEditTrueTradeInVisibility.vue?vue&type=template&id=4ba550b2&scoped=true&"
import script from "./ProductEditTrueTradeInVisibility.vue?vue&type=script&lang=js&"
export * from "./ProductEditTrueTradeInVisibility.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditTrueTradeInVisibility.vue?vue&type=style&index=0&id=4ba550b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba550b2",
  null
  
)

export default component.exports